import React, { useEffect } from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Welcome } from './components/Welcome';
import { Stats } from './components/Stats';
import { Spaces } from './components/Spaces';
import { ImageBreak } from './components/ImageBreak';
import { Experience } from './components/Experience';
import { Testimonials } from './components/Testimonials';
import { SocialProof } from './components/SocialProof';
import { GalleryPreview } from './components/GalleryPreview';
import { ContactCTA } from './components/ContactCTA';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    document.title = 'Copper Crest — Where Timeless Moments Begin';
    // Strip all HTML comments and keep watching for new ones
    const stripComments = () => {
      const walker = document.createTreeWalker(document.documentElement, NodeFilter.SHOW_COMMENT);
      const comments: Comment[] = [];
      while (walker.nextNode()) comments.push(walker.currentNode as Comment);
      comments.forEach(c => c.remove());
    };
    stripComments();
    const observer = new MutationObserver(() => stripComments());
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
    return () => observer.disconnect();
  }, []);
  return <div className="font-sans text-charcoal bg-cream min-h-screen selection:bg-copper/30 selection:text-charcoal" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <div className="relative z-10 -mt-32 md:-mt-44 lg:-mt-56 leading-[0]" data-id="element-4">
          <img src="https://cdn.magicpatterns.com/uploads/qDvWhtbE2p3xy683CVYTCW/trns-vid-image_1.png" alt="" className="w-full h-auto block" style={{
          filter: 'sepia(0.15) saturate(0.8) brightness(1.02)'
        }} aria-hidden="true" data-id="element-5" />
          <div className="absolute bottom-0 left-0 right-0 h-1/3 bg-gradient-to-t from-[#FAF7F2] to-transparent" data-id="element-6" />
        </div>
        <Welcome data-id="element-7" />
        <Stats data-id="element-8" />
        <Spaces data-id="element-9" />
        <ImageBreak data-id="element-10" />
        <Experience data-id="element-11" />
        <Testimonials data-id="element-12" />
        <SocialProof data-id="element-13" />
        <GalleryPreview data-id="element-14" />
        <ContactCTA data-id="element-15" />
      </main>
      <Footer data-id="element-16" />
    </div>;
}